import "../LoginFormItemInput/LoginFormItemInput.scss";
import React from "react";
import { Form, Input } from "antd";

interface ILoginFormItemInputPassword {
    name: string;
    placeholder?: string;
    label: string;
    rules: {required: boolean, message?: string};
    disabled?: boolean;
}

const LoginFormItemInputPassword: React.FC<ILoginFormItemInputPassword> = ({disabled, name, rules, placeholder, label}) => {
    return (
        <Form.Item
            className={`login-form__item`}
            name={name}
            label={label}
            rules={[{required: rules.required, message: rules.message}]}
        >
            <Input.Password
                className={"input password"}
                placeholder={placeholder}
                disabled={disabled}
            />
        </Form.Item>
    )
}

export default LoginFormItemInputPassword;